import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';

import './tagModule.scss';


const TagModuleView = props => (
  <div className="m-article-module">
    <div className={'m-tag-module'}>
      {props.tags.map(tag => (<Link to={`/${process.env.LENSPIRE_CHANNEL}/${props.lang}/#category=${tag.slug}`} key={tag.slug} className="m-tag-module__label">{tag.name}</Link>),
      )}
    </div>
  </div>
);


TagModuleView.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    slug: PropTypes.string,
  })),
  lang: PropTypes.string,
};

TagModuleView.defaultProps = {
  tags: [],
  lang: 'en',
};

export default withRouter(TagModuleView);



// WEBPACK FOOTER //
// ./frontend/js/Components/Modules/TagModule/TagModuleView.jsx